module.exports = __webpack_public_path__ + "static/media/Flame Assist.5ff11585.png";